import React from 'react';
import { Container, Row, Col } from 'reactstrap';

import { Divider } from 'primereact/divider';

const ListEvents = () => {

    const styles = {
        principal: {
            width: '100%',
            height: '600px'
        },
        headerTitle: {
            fontWeight: '800',
            fontFamily: 'Coveltica, sans-serif',
            fontSize: '50px',
            color: '#821520',
        },
        headerSubTitle: {
            fontWeight: '100',
            fontFamily: 'Coveltica, sans-serif',
            fontSize: '65px',
            color: '#821520',
        },
        headerDivText: {
            fontWeight: '200', // Agregar negrita al texto
            fontFamily: 'Coveltica, sans-serif',
            fontSize: '18px', // Agregar tamaño de fuente
            color: '#821520', // Agregar color de fuente
        },
        dividers: {
            fontWeight: '800',
            color: '#821520',
        }
    }
    return (
        <div className="coming-soon" id="coming" style={styles.principal}>
            <Container className="py-5 mt-5">
                <Row>
                    <Col md="6">
                        <div className="d-flex align-items-center">
                            <div>
                                <br />
                                <h2 style={styles.headerTitle} >Visualiza nuestras</h2>
                                <h2 style={styles.headerTitle} >publicaciones</h2>
                                <Divider style={styles.dividers} />
                                <h6 style={styles.headerDivText}>Aquí podrás revisar la línea de tiempo en la historia de la primera corte del Perú republicano. </h6>
                                {/*<a href="/cursos" className="btn btn-outline-light m-r-20 btn-md m-t-30 font-14" style={styles.headerDivText}>Click aquí</a>*/}
                                <a href="/listahistorias" className="btn btn-lg font-weight-bold font-14 m-t-20"
                                    style={{
                                        backgroundColor: '#821520', // Color de alto contraste
                                        color: 'white',
                                        border: `2px solid #821520`,
                                        padding: '10px 25px', // Más relleno para que sea prominente
                                        textTransform: 'uppercase'
                                    }}>
                                    Click aquí
                                </a>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default ListEvents;
